import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Desalination.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function Desalination() {

    useEffect(() => {
    
      trackPageVisit("Desalination");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);


     

  const DEFAULT_VALVES = {
  FCV_3901: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3902: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3903: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3904: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3905: { mode: "Manual", opening: 0, sp: "", pv: "" },


};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Desalination_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3901: { ...DEFAULT_VALVES.FCV_3901, ...parsed.FCV_3901 },
      FCV_3902: { ...DEFAULT_VALVES.FCV_3902, ...parsed.FCV_3902 },
      FCV_3903: { ...DEFAULT_VALVES.FCV_3903, ...parsed.FCV_3903 },
      FCV_3904: { ...DEFAULT_VALVES.FCV_3904, ...parsed.FCV_3904 },
      FCV_3905: { ...DEFAULT_VALVES.FCV_3905, ...parsed.FCV_3905 },


    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Desalination_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides } = usePlantStore();
            const TT_13001 = transmitters.TT_13001 || 0;
            const FIC_13007 = transmitters.FIC_13007 || 0;
            const TT_12001 = transmitters.TT_12001 || 0;
            const FIC_12007 = transmitters.FIC_12007 || 0;
            const FIC_13006 = transmitters.FIC_13006 || 0;
   






  const xv3901Open = !valves?.XV_3901;
  const xv3902Open = !valves?.XV_3902;
  const xv3903Open = !valves?.XV_3903;
  const xv3904Open = !valves?.XV_3904;
  const xv3905Open = !valves?.XV_3905;
  const xv3906Open = !valves?.XV_3906;




      
    const FIC_3901 =
        FIC_12007 && FIC_13007
            ? (FIC_12007 + FIC_13007)
            : FIC_12007 || FIC_13007 || 0;

    const TT_3901 = FIC_3901 > 0.03 ? 
        (TT_12001 && TT_13001
            ? (TT_12001 + TT_13001) / 2
            : TT_12001 || TT_13001 || 25) : 25;



    const FIC_3902 = FIC_13006;
    const TT_3902 = FIC_3902 > 0.03 ? TT_13001 : 25;



   const TT_3907 = xv3905Open ? 27.564 : 22;    // ================= FRESH WATER SUPPLY TO E-202
   const FIC_3903 = 8.564 * (valveData?.FCV_3901?.opening || 0)/100;    // ================= SOFT WATER SUPPLY TO V-202



   /* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-201A / P-201B STATUS
========================================================= */

const P201A_Running =
pumpData?.["P-201A"]?.running ?? false;

const P201B_Running =
pumpData?.["P-201B"]?.running ?? false;

const P201_Running =
P201A_Running || P201B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P201_CAPACITY = 1.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3902_Opening =
(valveData?.FCV_3902?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3904 =
(
P201_Running
)
?
P201_CAPACITY *
FCV3902_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3904 || 0);

const next =
current +
(targetFIC3904-current)*0.12;

return{

...prev,

FIC_3904:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3904
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3904 || 0.03);

const currentTemp =
Number(prev.TT_3904 || 28);

const currentFlow =
Number(prev.FIC_3904 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P201_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3902_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3902_Opening<0.20){

const restriction =
(0.20-FCV3902_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3902_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3902_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3902_Opening<0.20){

const restriction=
(0.20-FCV3902_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3904:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3904:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P201_Running,
FCV3902_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3904 = flowOverrides?.FIC_3904 ? 0 :
(Number(
processData.FIC_3904 || 0
));

const PT_3904 =
Number(
processData.PT_3904 || 0.03
);

const TT_3904 =
Number(
processData.TT_3904 || 28
);







/* =========================================================
   E-201A/B SOFT WATER / DRAIN WATER HEAT EXCHANGER
========================================================= */

const TT_3905 =
  processData.TT_3905;

const TT_3906 =
  processData.TT_3906;


/* =========================================================
   REFS
========================================================= */

const E201_intervalRef =
  useRef(null);

const E201_isMounted =
  useRef(false);

const TT_3905_Ref =
  useRef(
    processData.TT_3905 ?? 40
  );

const TT_3906_Ref =
  useRef(
    processData.TT_3906 ?? 80
  );

const E201_processRef =
  useRef({});


/* =========================================================
   KEEP VALUES UPDATED
========================================================= */

useEffect(() => {

  E201_processRef.current = {

    TT_3901,
    TT_3904

  };

});


/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  TT_3905_Ref.current =
    TT_3905 ?? 40;

}, [TT_3905]);


useEffect(() => {

  TT_3906_Ref.current =
    TT_3906 ?? 80;

}, [TT_3906]);


/* =========================================================
   E-201 HEAT EXCHANGER
========================================================= */

useEffect(() => {

  if (E201_isMounted.current)
    return;

  E201_isMounted.current = true;

  console.log(
    "✅ E-201 interval created"
  );

  E201_intervalRef.current =
    setInterval(() => {

      const {

        TT_3901,
        TT_3904

      } =
      E201_processRef.current;

      const hotInlet =
        Number(TT_3901 || 0);

      const coldInlet =
        Number(TT_3904 || 0);

      let targetTT3905 =
        coldInlet;

      let targetTT3906 =
        hotInlet;

      /* ==========================================
         HEAT TRANSFER
      ========================================== */

      if (
        hotInlet >
        coldInlet
      ) {

        const deltaT =
          hotInlet -
          coldInlet;

        /*
          Soft water gains
          up to about 80°C
        */

        const coldGain =
          Math.min(
            80,
            deltaT * 0.65
          );

        /*
          Salty water loses
          according to available ΔT
        */

        const hotLoss =
          Math.min(
            deltaT - 5,
            coldGain * 0.95
          );

        targetTT3905 =
          coldInlet +
          coldGain;

        targetTT3906 =
          hotInlet -
          hotLoss;

        /* ======================
           Physical limits
        ====================== */

        targetTT3905 =
          Math.min(
            targetTT3905,
            hotInlet - 5
          );

        targetTT3906 =
          Math.max(
            targetTT3906,
            coldInlet + 5
          );

      }

      /* ==========================================
         THERMAL LAG
      ========================================== */

      TT_3905_Ref.current +=
        (
          targetTT3905 -
          TT_3905_Ref.current
        ) * 0.08;

      TT_3906_Ref.current +=
        (
          targetTT3906 -
          TT_3906_Ref.current
        ) * 0.08;

      /* ==========================================
         UPDATE PROCESS DATA
      ========================================== */

      setProcessData(prev => ({

        ...prev,

        TT_3905: Number(
          TT_3905_Ref.current.toFixed(2)
        ),

        TT_3906: Number(
          TT_3906_Ref.current.toFixed(2)
        )

      }));

    }, 1000);

  return () => {

    console.log(
      "❌ E-201 interval cleared"
    );

    if (
      E201_intervalRef.current
    ) {

      clearInterval(
        E201_intervalRef.current
      );

      E201_intervalRef.current =
        null;

    }

    E201_isMounted.current =
      false;

  };

}, []);


    const PT_3905 = PT_3904 * 0.56;






    /* =========================================================
   E-202 COOLER
   PROCESS CONTEXT VERSION
========================================================= */

const TT_3908 =
  processData.TT_3908;

const TT_3909 =
  processData.TT_3909;


/* =========================================================
   REFS
========================================================= */

const E202_intervalRef =
  useRef(null);

const E202_isMounted =
  useRef(false);

const TT_3908_Ref =
  useRef(
    processData.TT_3908 ?? 35
  );

const TT_3909_Ref =
  useRef(
    processData.TT_3909 ?? 35
  );

const E202_processRef =
  useRef({});


/* =========================================================
   KEEP VALUES UPDATED
========================================================= */

useEffect(() => {

  E202_processRef.current = {

    TT_3902,
    TT_3906,
    TT_3907,
    xv3901Open,
    xv3902Open

  };

});


/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  TT_3908_Ref.current =
    TT_3908 ?? 35;

}, [TT_3908]);


useEffect(() => {

  TT_3909_Ref.current =
    TT_3909 ?? 35;

}, [TT_3909]);


/* =========================================================
   E-202 COOLER
========================================================= */

useEffect(() => {

  if (E202_isMounted.current)
    return;

  E202_isMounted.current = true;

  console.log(
    "✅ E-202 interval created"
  );

  E202_intervalRef.current =
    setInterval(() => {

      const {

        TT_3902,
        TT_3906,
        TT_3907,
        xv3901Open,
        xv3902Open

      } =
      E202_processRef.current;

      const waterInlet =
        Number(TT_3907 || 0);

      let hotInlet =
        0;

      let exchangerRunning =
        false;

      /* ==========================================
         SELECT HOT STREAM
      ========================================== */

      if (
        xv3901Open &&
        !xv3902Open
      ) {

        hotInlet =
          Number(TT_3906 || 0);

        exchangerRunning = true;

      }

      else if (
        !xv3901Open &&
        xv3902Open
      ) {

        hotInlet =
          Number(TT_3902 || 0);

        exchangerRunning = true;

      }

      /*
         If both valves are open,
         prioritize salty water.
      */

      else if (
        xv3901Open &&
        xv3902Open
      ) {

        hotInlet =
          Number(TT_3906 || 0);

        exchangerRunning = true;

      }

      let targetTT3908 =
        waterInlet;

      let targetTT3909 =
        hotInlet;

      /* ==========================================
         HEAT TRANSFER
      ========================================== */

      if (
        exchangerRunning &&
        hotInlet > waterInlet
      ) {

        const deltaT =
          hotInlet -
          waterInlet;

        /*
           Water heats up
        */

        const waterGain =
          Math.min(
            22,
            deltaT * 0.28
          );

        /*
           Hot stream cools
        */

        let hotLoss =
          Math.min(
            70,
            deltaT * 0.75
          );

        /*
           Crude normally leaves
           slightly hotter than
           salty water.
        */

        if (
          !xv3901Open &&
          xv3902Open
        ) {

          hotLoss =
            Math.min(
              87,
              deltaT * 0.92
            );

        }

        targetTT3908 =
          waterInlet +
          waterGain;

        targetTT3909 =
          hotInlet -
          hotLoss;

        /* ==========================
           Physical Limits
        ========================== */

        targetTT3908 =
          Math.min(
            targetTT3908,
            hotInlet - 5
          );

        targetTT3909 =
          Math.max(
            targetTT3909,
            waterInlet + 3
          );

      }

      /* ==========================================
         THERMAL LAG
      ========================================== */

      TT_3908_Ref.current +=
        (
          targetTT3908 -
          TT_3908_Ref.current
        ) * 0.08;

      TT_3909_Ref.current +=
        (
          targetTT3909 -
          TT_3909_Ref.current
        ) * 0.08;

      /* ==========================================
         UPDATE PROCESS DATA
      ========================================== */

      setProcessData(prev => ({

        ...prev,

        TT_3908: Number(
          TT_3908_Ref.current.toFixed(2)
        ),

        TT_3909: Number(
          TT_3909_Ref.current.toFixed(2)
        )

      }));

    }, 1000);

    return () => {

      console.log(
        "❌ E-202 interval cleared"
      );

      if (
        E202_intervalRef.current
      ) {

        clearInterval(
          E202_intervalRef.current
        );

        E202_intervalRef.current =
          null;

      }

      E202_isMounted.current =
        false;

    };

}, []);




const TT_39010 = xv3903Open &&  xv3902Open ? TT_3909 : 25;
const FIC_39010 = xv3903Open &&  xv3902Open ? FIC_3902 : 0;

const TT_39011 = !xv3904Open && xv3906Open && xv3901Open ? TT_3909 : TT_3906 || 25;
const FIC_39011 =
(
    (xv3904Open && xv3906Open && !xv3901Open) ||
    (!xv3904Open && xv3906Open && xv3901Open)
)
? FIC_3904
: 0;
    









useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
     current.FIC_3904 === FIC_3904
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3904
    }
  });

}, [FIC_3904]);








  return (
    <div className="Desalination-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "5px",
          left: "250px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 166px",
          zIndex: 10,
        }}
      >
        DESALINATION WATER INJECTION SUPPLY
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}


      {/* XV-3902 */}
      <Valve
        className="XV-3902"
        tag="XV_3902"
        x={1004}
        y={180}
        isClosed={valves.XV_3902}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3901 */}
      <Valve
        className="XV-3901"
        tag="XV_3901"
        x={942}
        y={190}
        isClosed={valves.XV_3901}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3903 */}
      <Valve
        className="XV-3903"
        tag="XV_3903"
        x={992}
        y={362}
        isClosed={valves.XV_3903}
        toggle={toggleValve}
      />

      {/* XV-3904 */}
      <Valve
        className="XV-3904"
        tag="XV_3904"
        x={868}
        y={410}
        isClosed={valves.XV_3904}
        toggle={toggleValve}
      />

      {/* XV-3905 */}
      <Valve
        className="XV-3905"
        tag="XV_3905"
        x={758}
        y={362}
        isClosed={valves.XV_3905}
        toggle={toggleValve}
      />

      {/* XV-3906 */}
      <Valve
        className="XV-3906"
        tag="XV_3906"
        x={992}
        y={452}
        isClosed={valves.XV_3906}
        toggle={toggleValve}
      />


      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3901 */}
        <div
            style={{ position: "absolute", left: 1000, top: 716}}
            onMouseEnter={() => setHoveredValve("FCV_3901")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3901")}
          >

            {hoveredValve === "FCV_3901" && (
              <div style={tagStyle}>
                FCV_3901
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3901">
                    
          <defs>
            <linearGradient id="metal_3901">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3901)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3901)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3902 */}
        <div
            style={{ position: "absolute", left: 262, top: 536, transform: "rotate(90deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_3902")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3902")}
          >

            {hoveredValve === "FCV_3902" && (
              <div style={tagStyle}>
                FCV_3902
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3902">
                    
          <defs>
            <linearGradient id="metal_3902">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3902)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3902)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

       


        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 390 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 390 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3901?.opening || 0)}
        x={1022}
        y={767}
      />


      <ValveOutput
        value={Number(valveData?.FCV_3902?.opening || 0)}
        x={245}
        y={554}
      />


    <Transmitter
        tag="FIC_3901"
        value={[FIC_3901]}
        x={835}
        y={70}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF SALTY DRAINED WATER FROM V-201 A/B TO E-201A/B"
      />

      <Transmitter
        tag="TT_3901"
        value={[TT_3901]}
        x={1045}
        y={70}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF SALTY DRAINED WATER FROM V-201 A/B TO E-201A/B"
      />

    <Transmitter
        tag="FIC_3902"
        value={[FIC_3902]}
        x={1035}
        y={135}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF CRUDE RETURN DESALTED OIL FROM V-201 B THROUGH P-505 TO E-202"
      />

      <Transmitter
        tag="TT_3902"
        value={[TT_3902]}
        x={1135}
        y={135}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF CRUDE RETURN DESALTED OIL FROM V-201 B THROUGH P-505 TO E-202"
      />

      <Transmitter
        tag="FIC_3903"
        value={[FIC_3903]}
        x={1085}
        y={705}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF SOFT WATER SUPPLY TO SOFT WATER TANK V-202"
      />

      <Transmitter
        tag="FIC_3904"
        value={[FIC_3904]}
        x={215}
        y={625}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF SOFT WATER FROM P-201A/B TO E-201A/B"
      />

      <Transmitter
        tag="TT_3904"
        value={[TT_3904]}
        x={215}
        y={685}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF SOFT WATER FROM P-201A/B TO E-201A/B"
      />

    <Transmitter
        tag="PT_3904"
        value={[PT_3904]}
        x={300}
        y={776}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF SOFT WATER FROM P-201A/B TO E-201A/B"
      />

       <Transmitter
        tag="TT_3905"
        value={[TT_3905]}
        x={300}
        y={105}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF SOFT WATER FROM E-201A/B TO V-201 A/B MIXING VALVE"
      />

    <Transmitter
        tag="PT_3905"
        value={[PT_3905]}
        x={300}
        y={156}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF SOFT WATER FROM E-201A/B TO V-201 A/B MIXING VALVE"
      />


      <Transmitter
        tag="TT_3906"
        value={[TT_3906]}
        x={650}
        y={450}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF SALTY DRAINED WATER FROM E-201 A/B TO E-202"
      />




    <Transmitter
        tag="TT_3907"
        value={[TT_3907]}
        x={655}
        y={337}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER SUPPLY TO E-202"
      />

    <Transmitter
        tag="TT_3908"
        value={[TT_3908]}
        x={755}
        y={147}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER RETURN TO WATER COOLING/TREATMENT"
      />

    <Transmitter
        tag="TT_3909"
        value={[TT_3909]}
        x={915}
        y={337}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF E-202 SHELL SIDE DISCHARGE OUTLET FOR EITHER CRUDE OR SALTY WATER"
      />

    <Transmitter
        tag="TT_39010"
        value={[TT_39010]}
        x={1075}
        y={352}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF CRUDE RETURN DESALTED OIL FROM E-202 LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_39010"
        value={[FIC_39010]}
        x={1165}
        y={337}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF CRUDE RETURN DESALTED OIL FROM E-202 LOADING GANTRY"
      />

    <Transmitter
        tag="TT_39011"
        value={[TT_39011]}
        x={1075}
        y={442}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF CRUDE RETURN DESALTED OIL FROM E-202 LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_39011"
        value={[FIC_39011]}
        x={1165}
        y={427}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF CRUDE RETURN DESALTED OIL FROM E-202 LOADING GANTRY"
      />







            <LevelTransmitterIndicator
              tag="LT_3901"
              totalLevel={2000}
              inflows={[FIC_3903]}
              outflows={[FIC_3904]}
              inflowTags={["FIC_3903"]}
              outflowTags={["FIC_3904"]}
              responseFactor={0.05}
              columnX={720}
              columnY={567}
              columnWidth={126}
              columnHeight={240}
              textX={630}
              textY={640}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.5}
              service="water"
            />


            <Pump
              tag="P-201A"
              x={448}
              y={706}
              rpm={1800}
              bladeCount={pumpData?.["P-201A"]?.bladeCount || 3}
              size={pumpData?.["P-201A"]?.size || 40}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-201B"
              x={448}
              y={786}
              rpm={1800}
              bladeCount={pumpData?.["P-201B"]?.bladeCount || 3}
              size={pumpData?.["P-201B"]?.size || 40}
              onClick={openPumpPanel}
            />









    </div>
  );
}

export default Desalination;